import script from "./BalDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./BalDropdown.vue?vue&type=style&index=0&id=46028b4e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46028b4e"]])

export default __exports__